import { ConfigurationItemEditor } from '@client/components/_core/configuration/ConfigurationItemEditor';
import { PageController } from '@client/components/_core/layout/PageController';
import { Space } from '@client/components/_ui/layout/Space';
import { useOrg } from '@client/hooks/business/org/useOrg';
import { createFileRoute } from '@tanstack/react-router';
import { Settings2 } from 'lucide-react';
import { IdentificationMethods } from '../IdentificationMethods';
import { IncidentTypes } from '../IncidentTypes';

export const Route = createFileRoute('/console/$orgId/configuration/compliance/incidents/general/incident-details')({
    staticData: {
        metadata: {
            title: 'Incident details',
        },
        ui: {
            icon: Settings2,
            title: 'Incident settings',
            subtitle: 'Types, causes, impacts, timeline and lodgement form configuration',
        },
    },
    component: IncidentDetailsOptions,
});

function IncidentDetailsOptions() {
    const { enabledModules } = useOrg();
    const isRiskFeatureEnabled = enabledModules.includes('risk');

    return (
        <PageController route={Route}>
            <Space orientation="vertical" size="middle" className="w-full">
                <IncidentTypes />
                <IdentificationMethods />
                <ConfigurationItemEditor
                    title="Part of the business impacted"
                    settingToEdit="INCIDENT_PRODUCTS_IMPACTED_ITEMS"
                    description="A list of impacted products for incidents."
                    editor={{ height: '150px' }}
                />
                {!isRiskFeatureEnabled && (
                    <ConfigurationItemEditor
                        title="Risks"
                        settingToEdit="INCIDENT_RISKS"
                        description="A list of risks for incidents."
                        editor={{ height: '150px' }}
                    />
                )}
            </Space>
        </PageController>
    );
}
